








import app from "@/app";
import { SXCompany, SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCompanySurveys extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;

	loading = false;

	get surveys() {
		let x = this;
		return app.services.surveys.select(undefined, function(item) {
			return item.company_id === x.company.id;
		});
	}

	created() {
		if (!this.surveys.length) {
			let x = this,
				always = () => (x.loading = false);
			x.loading = true;

			app.services.surveys.getAll(
				{
					filters: {
						[SXSurvey.COL_COMPANY_ID]: x.company.id
					}
				},
				always,
				always,
				false
			);
		}
	}
}
